// extracted by mini-css-extract-plugin
export default {"control-panel-frame":"styles_control-panel-frame__0lg46","header":"styles_header__2NgFj","footer":"styles_footer__1z94T","body":"styles_body__CDIlb"};